const loadMore = document.querySelector('button[data-target="more_article"]');
if (loadMore) {
    loadMore.addEventListener('click', function (e) {
        e.preventDefault();

        let totalPages = parseInt(loadMore.getAttribute('data-total_pages')),
            loadPage = parseInt(loadMore.getAttribute('data-need_page'));

        const container = document.querySelector('section.papers .papers__grid');

        fetch(`/article/load-more/` + loadPage, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        }).then((response) => response.text())
            .then((html) => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');

                let elems = doc.querySelectorAll('article.papers-item');
                if (elems.length) {
                    elems.forEach(function (elem) {
                        container.appendChild(elem);
                    })
                }
                loadPage = loadPage + 1;
                if (loadPage > totalPages)
                    loadMore.style.display = "none";
                else
                    loadMore.setAttribute('data-need_page', loadPage)

            });

    });
}
